import { gql } from "lib/apolloClient";
import {
  unitPlanFragmentV2,
  resolvedFieldValueFragmentV2,
} from "../UnitPlanFragments";

export const learningcourseUnitPlanItemFragment = {
  learningcourseUnitPlanItem: gql`
    fragment learningcourseUnitPlanItem on UnitPlan {
      id
      state
      startDate
      endDate
      isPublishedInSampleUnits
      isImported
      isSharedWithStudents @include(if: $showSharedWithStudentsFamily)
      isSharedWithFamilies @include(if: $showSharedWithStudentsFamily)
      curriculumProgram {
        ...curriculumProgramBasicDetailsItem
      }
      owner {
        id
        firstName
        middleName
        type
        lastName
        profileImage
      }
      createdBy {
        id
        firstName
        middleName
        type
        lastName
        profileImage
      }
      title {
        id
        value
      }
      unitCode {
        id
        value
      }
      courses {
        id
        title
      }
      grades
      unitType {
        id
        value
      }
      image {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldVideoAttachmentItem
        }
      }
      templateId
      exceptionalCollaborators(filters: $exceptionalCollaboratorsFilter) {
        totalCount
        edges {
          node {
            id
          }
          permission
        }
      }
      taggedPractices {
        ...taggedPracticesOnEvidence
      }
      academicYears {
        ...academicYearItem
      }
      submittedToCommunity
      fields(uids: $uids) {
        id
        uid
        value
        resolvedMinimalTree {
          ...unitPlanResolvedMinimalTreeItem
        }
      }
      createdAt
      updatedAt
      cascadeUpdatedBy {
        id
        firstName
        lastName
        profileImage
      }
      cascadeUpdateAt
      classDates(filters: $classFilter) {
        classId
        startDate
        endDate
      }
      learningCourseFlowResource {
        id
        state
        isSyncedWithAllTeacherCourse
        sharedDetails {
          class {
            id
            title
            profileImageData {
              url
              icon
              color
              acronym
            }
          }
          students {
            id
          }
        }
      }
      lockingInfo {
        isLocked
      }
      isUnitFlowLocked
      hasLockedGradingPeriodAssessment
      flowResourceCount {
        totalCount
      }
      isSyncedWithAllTeacherCourseV2(
        filters: { learningCourseId: $learningCourseId }
      ) {
        status
        isConflictExists
        courseSyncStatus {
          course {
            id
            title
          }
          status
        }
      }
    }
    ${unitPlanFragmentV2.curriculumProgramDetails}
    ${unitPlanFragmentV2.academicYearItem}
    ${unitPlanFragmentV2.taggedPractices}
    ${unitPlanFragmentV2.fieldVideoAttachment}
    ${resolvedFieldValueFragmentV2.resolvedMinimalTree}
  `,
};

export const learningCourseUnitPlanFeedFragment = {
  learningCourseUnitPlanFeed: gql`
    fragment learningCourseUnitPlanFeed on UnitPlan {
      ...learningcourseUnitPlanItem
      defaultStaffAccess
      enabledSections {
        userType
        sections
      }
      duration @include(if: $showWeeksDuration) {
        id
        value
      }
      resolvedGrades {
        id
        name
      }
      resourceLibrary {
        leCount @include(if: $showLE)
        assessmentCount @include(if: $showAssessments)
      }
      collaborators: allCollaborators(filters: $collaboratorsFilter) {
        totalCount
        isEditPermission
        edges @include(if: $showCollaborators) {
          permission
          node {
            id
            firstName
            middleName
            type
            lastName
            profileImage
          }
        }
      }
      subjects @include(if: $showSubjects) {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldSubject
        }
      }
      theme @include(if: $showSubjects) {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldTheme
        }
      }
      isSyncedFromBluePrintCourse
      learningCourse {
        id
        lockingInfo {
          isLocked
        }
      }
      isUnitFlowLocked
      hasLockedGradingPeriodAssessment
      flowResourceCount {
        totalCount
      }
    }
    ${learningcourseUnitPlanItemFragment.learningcourseUnitPlanItem}
    ${unitPlanFragmentV2.fieldTheme}
    ${unitPlanFragmentV2.fieldSubject}
  `,
  learningCourseUnitPlanCustomFeed: gql`
    fragment learningCourseUnitPlanCustomFeed on UnitPlan {
      id
      title {
        id
        value
      }
      image {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldVideoAttachmentItem
        }
      }
      subjects {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldSubject
        }
      }
      theme {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldTheme
        }
      }
      lockingInfo {
        isLocked
      }
      isUnitFlowLocked
      hasLockedGradingPeriodAssessment
      flowResourceCount {
        totalCount
      }

      isSyncedWithAllTeacherCourseV2(filters: { learningCourseId: $id }) {
        status
        isConflictExists
        courseSyncStatus {
          course {
            id
            title
          }
          status
        }
      }
    }
    ${unitPlanFragmentV2.fieldTheme}
    ${unitPlanFragmentV2.fieldVideoAttachment}
    ${unitPlanFragmentV2.fieldSubject}
  `,
};

export const learningCourseUnitPlansFragment = {
  learningCourseUnitPlans: gql`
    fragment learningCourseUnitPlans on LearningCourse {
      id
      unitPlans(
        first: $first
        after: $after
        filters: $filters
        orderBy: $orderBy
        orderByDirection: $orderByDirection
        groupBy: $groupBy
      ) {
        totalCount
        unitTypeCount {
          type
          count
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...learningCourseUnitPlanFeed
          }
        }
      }
    }
    ${learningCourseUnitPlanFeedFragment.learningCourseUnitPlanFeed}
  `,
};
